import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="bg-primary-500 rounded-2xl px-8 py-14 md:py-16">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
            开始探索海量资源
          </h2>
          <p className="text-sm md:text-base text-background-50/80 max-w-lg mx-auto mb-8 leading-relaxed">
            立即体验磁力猫强大的搜索功能，找到你想要的一切资源。免费、快速、无需注册。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/all"
              className="px-8 py-3.5 rounded-xl bg-background-50 text-primary-600 text-sm font-semibold hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              浏览全部资源
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 rounded-xl border-2 border-background-50/30 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}